var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "logo",
    "transform-origin": "14.3 12.5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5006 23.3495L18.0126 17.9941H9.34635L3.85831 23.3495L6.43337 25.8623L11.9214 20.5069C12.3919 20.0478 13.0122 19.7973 13.6795 19.7973C14.3468 19.7973 14.967 20.0478 15.4375 20.5069L20.9256 25.8623L23.5006 23.3495Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.928 16.4497L26.4221 18.4074L27.3632 14.9721L19.869 13.0144C19.2274 12.8475 18.6927 12.4468 18.359 11.8833C18.0254 11.3239 17.9399 10.6686 18.111 10.0425L20.1171 2.72948L16.5967 1.81118L14.5906 9.12419L18.9237 16.4456L18.928 16.4497Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.941051 18.4074L8.43524 16.4497L8.43952 16.4456L12.7726 9.12419L10.7665 1.81118L7.24609 2.72948L9.25224 10.0425C9.42334 10.6686 9.33779 11.3239 9.00415 11.8833C8.6705 12.4468 8.13582 12.8475 7.49419 13.0144L0 14.9721L0.941051 18.4074Z",
    fill: "currentColor"
  }))));
};
export default SvgLogoNoText;